import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { evaluateInAppRpc } from '../../../../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
import logError from '../../reliability/logError';
export const getParsedProductPurchaseMotions = ({
  location,
  apiName
}) => {
  const purchaseMotionsPromise = createRpcClientV2({
    hubHttpClient: http
  }).call(evaluateInAppRpc, {
    request: {
      locations: [location],
      productApiNames: [apiName]
    }
  }).then(purchaseMotionsResponse => {
    const purchaseMotions = purchaseMotionsResponse.purchaseMotionsMapping.productsByLocation[location].purchaseMotionsByProductApiName[apiName].purchaseMotions
    // Gracefully handle unhandled enum cases when new purchase motions
    // are returned from the service
    // https://git.hubteam.com/HubSpot/rpc-client-utils/blob/0e76bc994bbb475e33c15ebf630617be09c5f801/rpc-client-utils/static-1.2789/js/types.ts#L183-L204
    .map(purchaseMotion => readUnhandledEnumCase(purchaseMotion)).filter(purchaseMotion => {
      return typeof purchaseMotion === 'string';
    }).map(purchaseMotion => {
      return convertScreamingSnakeCaseToCamelCase(purchaseMotion);
    });
    if (!purchaseMotions || !purchaseMotions.length) {
      const error = {
        message: `Response is empty for apiName ${apiName} at location ${location}`,
        data: {
          location,
          apiName,
          response: purchaseMotionsResponse
        }
      };
      logError('getProductPurchaseMotionData', error);
    }
    return purchaseMotions;
  });
  purchaseMotionsPromise.catch(error => {
    if (error && error.status !== 0) {
      logError('getProductPurchaseMotionData', error);
    }
    return [];
  });
  return purchaseMotionsPromise;
};
function convertScreamingSnakeCaseToCamelCase(string) {
  return string.toLowerCase().replace(/_([a-z])/g, (__match, letter) => {
    return letter.toUpperCase();
  });
}